import {
  useAssetsIcons,
  useBanksDictionary,
  useDepositWithdrawAssetsDictionary,
} from '@/shared/api';
import { ACCOUNT_TYPES, useAccountsInfo } from '@/entities/account';

export const useDepositData = () => {
  const {
    accountsInfo,
    accountsInfoError,
    isAccountsInfoLoading,
    isAccountInfoError,
  } = useAccountsInfo();

  const mainAccount = accountsInfo?.accounts.find(
    acc => acc.accTypeName === ACCOUNT_TYPES.Main
  );
  const accountNumber = mainAccount?.accNum || '';

  const {
    depositWithdrawAssetsData,
    depositWithdrawAssetsLoading,
    depositWithdrawAssetsIsError,
    depositWithdrawAssetsError,
  } = useDepositWithdrawAssetsDictionary();

  const { banksData, isBanksLoading, isBanksError, banksError } =
    useBanksDictionary();

  const { assetsIconsData } = useAssetsIcons();

  const isDepositDataLoading =
    depositWithdrawAssetsLoading || isBanksLoading || isAccountsInfoLoading;
  const hasDataError = depositWithdrawAssetsIsError || isBanksError;
  const firstError = depositWithdrawAssetsIsError
    ? depositWithdrawAssetsError
    : banksError;

  return {
    // Account data
    accountsInfo,
    accountsInfoError,
    isAccountsInfoLoading,
    isAccountInfoError,
    mainAccount,
    accountNumber,

    // Assets data
    depositWithdrawAssetsData,
    depositWithdrawAssetsLoading,
    depositWithdrawAssetsIsError,
    depositWithdrawAssetsError,

    // Banks data
    banksData,
    isBanksLoading,
    isBanksError,
    banksError,

    // Icons data
    assetsIconsData,

    // Computed states
    isDepositDataLoading,
    hasDataError,
    firstDepositDataError: firstError,
  };
};
